/**
 * Creates a DOM element with the specified properties
 * @param tagName The HTML tag name
 * @param options Element options including styles, ID, and parent element
 * @returns The created HTML element
 */
function createElement(tagName, options) {
    if (options === void 0) { options = {}; }
    var element = document.createElement(tagName);
    if (options.styles) {
        Object.entries(options.styles).forEach(function (_a) {
            var prop = _a[0], value = _a[1];
            element.style[prop] = value;
        });
    }
    if (options.id) {
        element.id = options.id;
    }
    if (options.parent) {
        options.parent.appendChild(element);
    }
    return element;
}

export { createElement };
